import React from 'react';
import PropTypes from 'prop-types';
import { Select } from '@pitchero/react-ui';
import { SEASONS_PROP_TYPES } from '../../../lib/prop-types/season';

const SeasonFilter = ({ seasons, selected, onChange }) => {
  const selectOptions = seasons.map((season) => ({
    value: season.id,
    name: season.name,
    disabled: false,
  }));

  const disabled = selectOptions.length === 1;

  return (
    <Select
      options={selectOptions}
      onChange={onChange}
      disabled={disabled}
      value={selected || ''}
    />
  );
};

SeasonFilter.defaultProps = {
  selected: '',
};

SeasonFilter.propTypes = {
  onChange: PropTypes.func.isRequired,
  seasons: SEASONS_PROP_TYPES.isRequired,
  selected: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default SeasonFilter;
